import {
  yesNoSchema,
  yesNoUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['military-va-benefits-title']),
    receivedBenefits: yesNoUI({
      title: content['military-va-benefits-question'],
    }),
  },
  schema: {
    type: 'object',
    required: ['receivedBenefits'],
    properties: {
      receivedBenefits: yesNoSchema,
    },
  },
};
